var $7ed9c6fad16a15ec$exports = {};
$7ed9c6fad16a15ec$exports = {
  "rangeOverflow": args => `Vrednost mora da bude ${args.maxValue} ili starija.`,
  "rangeReversed": `Datum po\u{10D}etka mora biti pre datuma zavr\u{161}etka.`,
  "rangeUnderflow": args => `Vrednost mora da bude ${args.minValue} ili novija.`,
  "unavailableDate": `Izabrani datum nije dostupan.`
};
export { $7ed9c6fad16a15ec$exports as default };